import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, Optional } from '@angular/core';
import { AuthService } from '@sprint-backoffice/app/core/auth/auth.service';
import {
  OAuthModuleConfig,
  OAuthResourceServerErrorHandler,
} from 'angular-oauth2-oidc';
import { from, Observable } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private errorHandler: OAuthResourceServerErrorHandler,
    @Optional() private moduleConfig: OAuthModuleConfig
  ) {}

  private checkUrl(url: string): boolean {
    return !!this.moduleConfig.resourceServer.allowedUrls.find(u =>
      url.startsWith(u)
    );
  }

  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const url = req.url.toLowerCase();

    if (
      !this.moduleConfig ||
      !this.moduleConfig.resourceServer ||
      !this.moduleConfig.resourceServer.allowedUrls ||
      !this.checkUrl(url)
    ) {
      return next.handle(req);
    }

    if (this.authService.hasValidAccessToken()) {
      return this.handleRequestWithToken(req, next);
    } else {
      // Refresh token if invalid or about to expire
      return from(this.authService.refreshToken()).pipe(
        switchMap(() => this.handleRequestWithToken(req, next)),
        catchError(err => this.errorHandler.handleError(err))
      );
    }
  }

  private handleRequestWithToken(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = this.authService.accessToken;
    const headers = req.headers.set('Authorization', 'Bearer ' + token);
    const clonedReq = req.clone({ headers });
    return next.handle(clonedReq);
  }
}
